module.exports = __webpack_public_path__ + "img/c07_unittechulfhednarchampion_Normal_ua.c8fd6d62.webp";